module.exports = __webpack_public_path__ + "img/b4-1.a52ef12.png";